/**
 * Server default: the auth worker sets no `emailAndPassword.minPasswordLength`
 * override, so better-auth's built-in default of 8 applies.
 *
 * Both apps check this client-side BEFORE calling `resetPassword` /
 * `changePassword`: `resetPasswordEmailOTP` verifies (and consumes) the OTP
 * *before* checking password length, so a correct code plus a too-short
 * password would otherwise burn the OTP and leave the user stuck re-entering a
 * now-invalid code.
 */
export const MIN_PASSWORD_LENGTH = 8;

/**
 * How often (seconds) a signed-in client re-asks the auth worker for its
 * session while the app is open — better-auth's `sessionOptions.refetchInterval`.
 *
 * This is what makes "log out other devices" reach a device that is sitting in
 * the foreground: nothing pushes a revocation, the client's store only learns
 * it was revoked when it next fetches `/get-session` (cold start, native
 * foreground, browser tab focus — none of which happen while the user keeps
 * using the app). The poll bounds that to this many seconds; both clients use
 * the same value so the two platforms sign out on the same clock.
 *
 * The mobile client must ALSO pass `refetchWhenOffline: true` for that to be
 * true of it: better-auth gates each polled refetch on the online manager,
 * which reads `navigator.onLine` — undefined under React Native, so the gate is
 * permanently falsy and the interval fires into nothing. See the comment in
 * flashka-app/src/auth/better/client.ts. Setting this value without that flag
 * silently buys mobile nothing.
 *
 * One tiny GET per interval per open signed-in app — it only runs while the
 * store holds a session.
 */
export const SESSION_REFETCH_INTERVAL_S = 30;
